import { ChangeEvent } from "react";

interface InputFieldProps {
  type?: string;
  value: string;
  placeholder?: string;
  label?: string;
  error?: string;
  onChange: (value: string) => void;
  onClick?: () => void;
  children?: React.ReactNode;
}

const InputField: React.FC<InputFieldProps> = ({
  type,
  value,
  onChange,
  placeholder,
  children,
  onClick,
  label,
  error = "",
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <div>
      <label className="block text-sm text-gray-700">{label}</label>
      {children}
      <input
        onClick={onClick}
        placeholder={placeholder}
        type={type || "text"}
        value={value}
        onChange={handleChange}
        className={`border p-2 w-full rounded-md mt-1 ${
          error!.length > 0 ? "border-red-500" : ""
        }`}
        required
      />
    </div>
  );
};
export default InputField;
